$(function () {
    'use strict';

    var page = 0;
    var key = 'transfergeruchten-v2';
    var cookievalTG = store(key);

    var transfergeruchten = {};
    if (typeof cookievalTG === 'string') {
        transfergeruchten = JSON.parse(cookievalTG);
        // transfergructhen = [] [1,2,]
    } else if (cookievalTG && (cookievalTG instanceof Array || typeof cookievalTG === 'object')) {
        transfergeruchten = cookievalTG;
    }

    var onInitGeruchten = function () {
        $('article[data-newsid]').each(function () {
            var $article = $(this);
            var newsid = $article.attr('data-newsid');
            var $poll = $article.find('.rumour-poll');

            if (
                transfergeruchten &&
                (transfergeruchten[newsid] === false || transfergeruchten[newsid] === true)
            ) {
                $poll
                    .toggleClass('voted-true', transfergeruchten[newsid])
                    .toggleClass('voted-false', !transfergeruchten[newsid]);

                $poll.find('section.vote').css('display', 'none', function () {
                    $poll.find('section.results').show();
                });
            } else {
                $poll.find('section.results').css('display', 'none');
                $poll.find('section.vote').show();
            }
        });
    };
    onInitGeruchten();

    // VOTE TRANSFERGERUCHTEN
    var pollurl = '/requests/index.php?domain_id=' + domain_id;
    $(document).on('click', '.vote a', function (e) {
        e.preventDefault();

        var $poll = $(this).parents('.rumour-poll');
        var $article = $(this).parents('article');
        var newsid = $article.attr('data-newsid');

        var t = $(this).attr('id').split('_');
        var votedTrue = t[0] === 'newsup';

        transfergeruchten[newsid] = votedTrue;
        store(key, JSON.stringify(transfergeruchten));

        $poll
            .toggleClass('voted-true', votedTrue)
            .toggleClass('voted-false', !votedTrue)
            .find('.vote')
            .fadeOut('Fast', function () {
                $poll.find('section.results').show();
                $poll.find('.progress_bar').fadeIn('Fast').css({
                    display: 'inline-block',
                    position: 'relative',
                });
            });

        return (
            t[1] &&
            $.post(
                pollurl,
                {
                    type: t[0],
                    newsID: t[1],
                },
                function (s) {
                    onInitGeruchten();
                }
            )
        );
    });

    $(document).on('click', '.js-load-rumours', function () {
        page++;
        var $button = $(this);

        $.ajax({
            type: 'GET',
            url: '',
            data: {
                ajax: true,
                page: page,
            },
            success: function (html) {
                var $html = $(html).find('article.transfer-rumour');
                if ($html.length) {
                    $('article.transfer-rumour').last().after($html);
                    onInitGeruchten();
                } else {
                    $button.remove();
                }
            },
        });
        return false;
    });
});
